import * as jQuery from "jquery";
const $ = jQuery.default;
import slick from 'slick-carousel';
// import lightbox from 'lightbox';

// cookie functions - https://www.w3schools.com/js/js_cookies.asp
function ms_getCookie(cname) {
	var name = cname + "=";
	var decodedCookie = decodeURIComponent(document.cookie);
	var ca = decodedCookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') {
			c = c.substring(1);
		}
		if (c.indexOf(name) == 0) {
			return c.substring(name.length, c.length);
		}
	}
	return "";
}


function ms_setCookie(cname, cvalue, exdays) {
	var d = new Date();
	d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	var expires = "expires=" + d.toUTCString();
	document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}


function accessoriesReferrer() {
	if ($('body').hasClass('product-page-accessories')) {
		var pageReferrer =  document.referrer;

		if (pageReferrer.includes("products/")) {
			ms_setCookie('accessoriesReferrer', true, 720);
		}
	} else if (!$('body').hasClass('product-page-products')) {
		ms_setCookie('accessoriesReferrer', false, 720);
	}
}
accessoriesReferrer();

if ($('body').hasClass('product-page-products')) {
	var accessoriesReferrerCookieValue = ms_getCookie("accessoriesReferrer")
	if (accessoriesReferrerCookieValue == "true") {
		$(".feature-tabs__navigation-item").attr('data-default', 'false')
		var accessoryButton = $(".feature-tabs__navigation-item:contains('Accessories')");
		accessoryButton.attr('data-default', 'true')
	}
}

if ($('.js-load-trigger[data-default]')[0]) {
	$('.js-load-trigger[data-default="true"]').addClass('active');
	var url = $('.js-load-trigger[data-default="true"]').attr('data-target');
	$('.js-load-destination').load(url+' .js-load-content');
}

$('.js-load-trigger').click(function(){
	var url = $(this).attr('data-target');
	$('.js-load-destination').load(url+' .js-load-content');
	$('.js-load-trigger').removeClass('active');
	$(this).addClass("active");
	return false;
});

function equalHeights(el) {
	var findElement = $(el);
	var tallest = 0;

	findElement.css({
		'height': 'auto'
	});

	// Loop over matching divs
	for (var i = 0; i < findElement.length; i++) {
		var ele = findElement[i];
		var eleHeight = ele.offsetHeight;
		tallest = (eleHeight > tallest ? eleHeight : tallest); /* look up ternary operator if you dont know what this is */
	}
	for (var i = 0; i < findElement.length; i++) {
		findElement[i].style.height = tallest + 'px';
	}
}

function overlayTriangle () {
	if ($('.overlay-triangle').length) {
		var style = '';
		var rows = [];
		$('.overlay-row').each(function (i) {
			$(this).addClass('overlay-row__' + i)

			var children = $(this).find('.overlay-triangle');

			equalHeights(children);

			var childHeight = children.outerHeight();

			rows.push('.overlay-row__' + i + ' .overlay-triangle::after { border-top: ' + childHeight + 'px solid rgba(44, 184, 91, .5); }');
		});

		for (var i = 0; i < rows.length; i++) {
			style += rows[i];
		}

		if ($('head style[data-class="overlay-fix"]').length) {
			$('head style[data-class="overlay-fix"]').replaceWith('<style data-class="overlay-fix">' + style + '</style>')
		} else {
			$('head').append('<style data-class="overlay-fix">' + style + '</style>');
		}
	}
}


function cardAccordion () {
	$('.card-accordion__heading').each(function () {
		$(this).next(".card-accordion__draw").slideUp();
		$(this).click(function() {
			$(this).next(".card-accordion__draw").slideToggle();
			$(this).toggleClass("card-accordion__heading--open");
		});
	});
}
cardAccordion();

function childCardAccordion() {
	$('.js-child-accordion-heading').each(function() {
		$(this).next(".card-accordion__child-draw").slideUp();
		$(this).click(function() {
			$(this).next(".card-accordion__child-draw").slideToggle();
			$(this).toggleClass("card-accordion__sub-heading--open");
		});
	});
}
childCardAccordion();

// LOOKS AT THE CONTENT OF THE DISTRIBUTOR ACCORDION & REMOVES HEADINGS WITH NO FOLLOWING CARDS.
// WAS MUCH SIMPLER TO DO IN JS THAN ADDING EXTRA CHECKS TO THE ALREADY COMPLICATED CRAFT TEMPLATING
function distributorCardAccordion () {
	// $('.card-accordion__sub-heading').each(function () {
	// 	if (!$(this).next().hasClass("card-accordion__card") && !$(this).next().hasClass("card-accordion__sub-heading--small") ) {
	// 		$(this).addClass("card-accordion__sub-heading--hidden")
	// 	}
	// });

	// $('.card-accordion__sub-heading--small').each(function () {
	// 	if (!$(this).next().hasClass("card-accordion__card") ) {
	// 		$(this).addClass("card-accordion__sub-heading--hidden")
	// 	}
	// });

	const childDrawers = document.querySelectorAll('.card-accordion__child-draw');
	Array.from(childDrawers, (childDrawer) => {
		if (childDrawer.childNodes.length == 1) document.querySelector(`.card-accordion__sub-heading[data-id="${childDrawer.dataset.id}"]`).style.display = 'none';
	});
}
distributorCardAccordion();


function readMore () {
	if ($(".js-read-more").length) {
		$(".js-read-more + *").slideUp()
		$('.js-read-more').click(function() {
			$(this).next().slideToggle();
		});
	}
}
readMore();

function videoModal () {
	if ($(".js-modal").length) {
		$('.js-modal').click(function() {
			$('.video-modal').addClass('video-modal--active');
		});

		$('.js-modal-close').click(function() {
			$('.video-modal').removeClass('video-modal--active');
		});
	}
}
videoModal();



$('.js-nav-toggle').click(function() {
	$(this).toggleClass('nav-toggle--active');
	$('.nav').toggleClass('nav--active');
});

if ($(window).width() <= 1000) {
	$('.nav__sub-list').slideUp();
	$('.nav__sub-list').before('<button class="nav__drawer-toggle"></button>');

	$('.nav__drawer-toggle').click(function() {
		$(this).toggleClass('nav__drawer-toggle--active');
		$(this).siblings('.nav__sub-list').slideToggle();
	});
}


(function ($) {
	// Allows you to query the window width against the breakpoints. These MUST match breakpoints
	// set in _vars.scss
	var $breakpoints = {
		'xs': '0',
		'sm': '568',
		'md': '768',
		'lg': '992',
		'xl': '1280',
		'xxl': '1500'
	};
	var wW = $(window).width();

	// newsletter pop up script
	var newsletterSignup = function () {
		var nls_info = {
			"firstVisit": function () {
				if (ms_getCookie('nls_firstVisit')) {
					return ms_getCookie('nls_firstVisit');
				} else {
					var d = new Date();
					ms_setCookie('nls_firstVisit', d.getTime(), 720);
					return ms_getCookie('nls_firstVisit');
				}
			},
			"lastVisit": ms_getCookie('nls_lastVisit'),
			"setLastVisit": function () {
				var d = new Date();
				ms_setCookie('nls_lastVisit', d.getTime(), 720);
			},
			"hasClosed": function () {
				if (ms_getCookie('nls_hasClosed')) {
					return ms_getCookie('nls_hasClosed');
				} else {
					return "false";
				}
			},
			"hasSubscribed": function () {
				if (ms_getCookie('nls_hasSubscribed')) {
					return ms_getCookie('nls_hasSubscribed');
				} else {
					return "false";
				}
			}
		}
		// set the time now
		var timeNow = new Date();
		// show pop up.
		if (parseInt(nls_info.lastVisit) <= (timeNow.getTime() - 1800000) && nls_info.hasClosed() != "true" && nls_info.hasSubscribed() != "true") {
			document.querySelector('.signupModal').classList.add('signupModal--active');
		}
		// set has closed cookie is pop up closed.
		$('.signupModal__close').on('click', function () {
			$(this).closest('.signupModal').removeClass('signupModal--active');
			ms_setCookie('nls_hasClosed', "true", 90);
		});
		// set has subscribed once form submitted.
		$('.signupModal form').on('submit', function () {
			ms_setCookie('nls_hasSubscribed', "true", 3650);
		});
		// run info cookies
		nls_info.firstVisit(); // only updates if not set.
		nls_info.setLastVisit();
	}
	newsletterSignup();

	function angleBoxesHeight(el) {
		var findElement = $(el);
		var tallest = 0;

		findElement.css({
			'height': 'auto'
		});

		// Loop over matching divs
		for (var i = 0; i < findElement.length; i++) {
			var ele = findElement[i];
			var eleHeight = ele.offsetHeight;
			tallest = (eleHeight > tallest ? eleHeight : tallest); /* look up ternary operator if you dont know what this is */
		}
		for (var i = 0; i < findElement.length; i++) {
			findElement[i].style.height = (tallest - 20) + 'px';
		}
	}

	function dropdownWidth(wW) {
		if (wW >= $breakpoints.md) {
			$('.nav__dropdown').each(function () {
				var offsetLeft = $(this).parents('.nav__item').offset().left,
					parentWidth = $(this).parents('.nav__item').width(),
					maxWidth = 0,
					$element;

				$(this).find('.nav__item, .nav__link').attr('style', '');

				$(this).attr('style', '').find('.nav__link').each(function () {
					$element = $(this);
					if ($element.outerWidth() > maxWidth) {
						maxWidth = $element.outerWidth();
					}
				});

				if (maxWidth > parentWidth) {
					$(this).width(maxWidth + 2);
				} else {
					$(this).css({
						'width': 'calc(100% + 30px)'
					});
				}

				$(this).find('.nav__item, .nav__link').css({
					'display': 'block'
				});

				$(this).hide().css({
					'opacity': '1'
				});

				if ((offsetLeft + maxWidth) > wW) {
					$(this).addClass('nav__dropdown--right');
				}
			});
		} else {
			$('.nav__dropdown').attr('style', '').show();
		}
	}

	// Modal function
	// Speak to Pete for more info
	function modal($target) {
		$('body').addClass('modal--open').find('.js-modal-close, .modal__cover').on('click', function (e) {
			e.preventDefault();
			$('body').removeClass('modal--open');
		});
		return false;
	}

	// Select all links with hashes
	$('a[href*="#"]')
		// Remove links that don't actually link to anything
		.not('[href="#"]')
		.not('[href="#0"]')
		.not('[href="#!"]')
		.click(function (event) {
			// On-page links
			if (
				location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') &&
				location.hostname == this.hostname
			) {
				// Figure out element to scroll to
				var target = $(this.hash);
				target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
				// Does a scroll target exist?
				if (target.length) {
					// Only prevent default if animation is actually gonna happen
					event.preventDefault();
					$('html, body').animate({
						scrollTop: target.offset().top
					}, 1000, function () {
						// Callback after animation
						// Must change focus!
						var $target = $(target);
						$target.focus();
						if ($target.is(":focus")) { // Checking if the target was focused
							return false;
						} else {
							$target.attr('tabindex', '-1'); // Adding tabindex for elements not focusable
							$target.focus(); // Set focus again
						};
					});
				}
			}
		});

	// Triggered when the DOM is loaded

	$(document).ready(function () {
		if ($(".js-product-slider").length) {
			$('.js-product-slider').slick({
				'lazyLoad': 'ondemand',
				'arrows': false,
				'dots': true,
				'slidesToShow': 1,
				'slidesToScroll': 1
			});
		}

		$('.js-modal-trigger').on('click', function () {
			var $this = $(this),
				target = $this.data('target');
			//content = $this.data('modal-content');
			modal(target);
		});

		if ($('.js-adaptions-view').length) {
			adaptionsScript();
		}

		dropdownWidth(wW);

		$('.js-hamburger').on('click', function () {
			if ($(this).hasClass('is-active')) {
				$(this).removeClass('is-active');
				$('.js-nav').stop().slideUp();
			} else {
				$(this).addClass('is-active');
				$('.js-nav').stop().slideDown();
			}
		});

		
		if ($('.accordion').length) {
			$('.accordion').each(function () {
				var $container = $(this);

				$container.find('.accordion__item:first-of-type .accordion__content').stop().slideDown();

				$container.find('.accordion__title').on('click', function () {
					var $parent = $(this).parents('.accordion__item');
					if (!$parent.hasClass('.accordion__item--active')) {
						$container.find('.accordion__item--active .accordion__content').stop().slideUp();
						$container.find('.accordion__item--active').removeClass('accordion__item--active');

						$parent.addClass('accordion__item--active')
						$(this).next('.accordion__content').stop().slideDown();
					}
				});
			});
		}

	}); // docReady

	// Triggered when the entire page is loaded (including images)
	$(window).on('load', function () {
		// adds a playing prop to media
		Object.defineProperty(HTMLMediaElement.prototype, 'playing', {
			get: function () {
				return !!(this.currentTime > 0 && !this.paused && !this.ended && this.readyState > 2);
			}
		});

		if ($('.js-hero-vid').length) {
			if (document.querySelector('.js-hero-vid').playing) {
				$('.js-hero-vid-img').fadeOut();
			}

			$('.js-hero-vid').on('play', function () {
				$('.js-hero-vid-img').fadeOut();
			});
		}

		if ($('.overlay-triangle').length) {
			var style = '';
			var rows = [];
			$('.overlay-row').each(function (i) {
				$(this).addClass('overlay-row__' + i)

				var children = $(this).find('.overlay-triangle');

				equalHeights(children);

				var childHeight = children.outerHeight();

				if (childHeight == null) {
					childHeight = $('.overlay-triangle').outerHeight();
				}

				rows.push('.overlay-row__' + i + ' .overlay-triangle::after { border-top: ' + childHeight + 'px solid rgba(44, 184, 91, .5); }');
			});

			for (var i = 0; i < rows.length; i++) {
				style += rows[i];
			}

			if ($('head style[data-class="overlay-fix"]').length) {
				$('head style[data-class="overlay-fix"]').replaceWith('<style data-class="overlay-fix">' + style + '</style>')
			} else {
				$('head').append('<style data-class="overlay-fix">' + style + '</style>');
			}
		}

		if ($(".js-articles-slider").length) {
			$('.js-articles-slider').slick({
				'arrows': false,
				'dots': true,
				'slidesToShow': 5,
				'slidesToScroll': 3,
				'infinite': true
			});
		}

		if ($(".js-carousel").length) {
			$('.js-carousel').slick({
				'arrows': false,
				'dots': true,
				'slidesToShow': 4,
				'slidesToScroll': 4,
				'appendDots': $('.js-carousel--append')
			});
		}

		if ($(".js-carousel--dots").length) {
			$('.js-carousel--dots').slick({
				'arrows': false,
				'dots': true,
				'slidesToShow': 1,
				'slidesToScroll': 1,
			});
		}

		if ($(".js-grid-carousel").length) {
			$('.js-grid-carousel').slick({
				'arrows': false,
				'asNavFor': $('.js-grid-carousel--dots')
			});

			$('.js-grid-carousel--dots').slick({
				'arrows': false,
				'dots': true,
				'asNavFor': $('.js-grid-carousel')
			});
		}

		overlayTriangle();
	}); // winLoad

	// Triggered on scroll
	$(window).on('scroll', function () {
		var windowH = $(window).height(),
			scrollPos = $(this).scrollTop();
	}); // winScroll

	// Triggered on resize, or when switching from landscape to portrait on mobile
	$(window).on('resize orientationchange', function () {
		var wW = $(window).width();

		overlayTriangle();
		dropdownWidth(wW);

	}); // winResize

	// GA event tracking
	$('[href*="mailto:"]').on('click', function () {
		var linkedEmail = $(this).attr('href');
		tracker("Tracked Events", "Email link clicked", linkedEmail);
	});

	$('[name="WebToContacts933435000003582009"]').on('submit', function () {
		var submittedEmail = $(this).find('[name="Email"]').val();
		tracker("Tracked Events", "Newsletter subscribe", submittedEmail);
	});

	function tracker(category, action, opt_label) {
		try {
			ga('send', 'event', category, action, opt_label);
		} catch (error) {
			console.log("GA tracking failed for '" + category + "' '" + action + "' '" + opt_label + "' - either tracking preference has been set to false or GA script is missing. (note: no tracking in dev mode.)");
		}
	}

	// Adaptions page
	var adaptionsScript = function () {
		//set view to content height.
		var $setViewHeight = 0;
		$('.js-adaptions-product').each(function () {
			var $height = $(this).outerHeight();
			$setViewHeight = $setViewHeight > $height ? $setViewHeight : $height;
		});
		$('.js-adaptions-placeholder').css({
			'height': $setViewHeight
		});
		$('.js-adaptions-view').css({
			'height': $setViewHeight
		});

		//fold all products into the same space
		var $currentFold = 0;
		$('.js-adaptions-product').each(function () {
			$(this).css({
				'top': $currentFold
			});
			$currentFold = $currentFold - $(this).outerHeight();
		});

		//set out of view classes on non default product
		$('.js-adaptions-product').addClass('adaptions__product--out');
		$('.js-adaptions-product[data-trike="mt"]').removeClass('adaptions__product--out');
		$('.js-adaptions-trigger[data-trike="mt"]').addClass('js-active');

		//on button click switch products
		$('.js-adaptions-trigger').on('click', function () {
			var $product = $(this).data('trike');
			if ($('.js-adaptions-product[data-trike="' + $product + '"]').hasClass('adaptions__product--out')) {
				$('.js-adaptions-trigger').removeClass('adaptions__nav-button--active');
				$(this).addClass('adaptions__nav-button--active');
				$('.js-adaptions-product').addClass('adaptions__product--out');
				setTimeout(function () {
					$('.js-adaptions-product[data-trike="' + $product + '"]').removeClass('adaptions__product--out');
				}, 300);
			}
		});

		//on product feature click
		$('.js-feature-trigger').on('click', function () {
			var $product = $(this).data('trike');
			if ($('.js-adaptions-product[data-trike="' + $product + '"]').hasClass('adaptions__product--out')) {
				$('.js-adaptions-trigger').removeClass('adaptions__nav-button--active');
				$('.js-adaptions-trigger[data-trike="' + $product + '"]').addClass('adaptions__nav-button--active');

				$('.js-adaptions-product').addClass('adaptions__product--out');
				setTimeout(function () {
					$('.js-adaptions-product[data-trike="' + $product + '"]').removeClass('adaptions__product--out');
				}, 300);
			}
		});

		setTimeout(function () {
			$('.js-adaptions-placeholder').fadeOut('slow');
		}, 700);
	}
})(jQuery);
